<template>
    <div class="loader-wrapper">
        <div class="loader-container" ref="container">
            <div class="loader" ref="loader"></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'loader',
        props: {
            size: {
                default: 80
            },
            position: {
                type: String,
                default: 'absolute'
            }
        },
        mounted() {
            Object.assign(this.$refs.container.style,{
                width: this.size * 2.5 + 'px',
                position: this.position
            });
            Object.assign(this.$refs.loader.style,{
                borderWidth: this.size / 5 + "px",
                borderTopWidth: this.size / 5 + "px",
                width: this.size + "px",
                height: this.size + "px"
            });
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../sass/_variables.scss";

    .loader-wrapper {
        z-index: 10000;
        height: 100%;
    }

    .loader-container {
        z-index: 10001;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .loader {
        border-radius: 50%;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
        margin: 0 auto;
        border-style: solid;
        border-color: #f3f3f3;
        border-top-color: $primary-color;
    }

    /* Safari */
    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
